import { Activities } from './activities';
import { ApplyToAllPagesDialogHost } from './components/ApplyToAllPagesDialog';
import { BlueprintCalibrationPanel } from './components/BlueprintCalibrationPanel';
import { DesignAiChatTestPanel } from './components/DesignAiChatTestPanel';
import { DesignCommentsPanel } from './components/DesignCommentsPanel';
import { Results } from './Results';
import { Map3d } from './Map3d';
import { Storeys } from './storeys/Storeys';

/**
 * Design view components
 */
export const Design = {
  Map3d: Map3d,
  Activities,
  AiChatTest: DesignAiChatTestPanel,
  Comments: DesignCommentsPanel,
  BlueprintCalibration: BlueprintCalibrationPanel,
  ApplyToAllPagesDialog: ApplyToAllPagesDialogHost,
  Storeys,
  Results,
};
